export default "__VITE_ASSET__DLu5BiLs__"